import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { GuidedTourEffects } from './+state/guided-tour.effects';
import { guidedTourFeature } from './+state/guided-tour.reducer';

export function provideGuidedTourDomain() {
  return makeEnvironmentProviders([provideState(guidedTourFeature), provideEffects(GuidedTourEffects)]);
}
